// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"513":"811bb94d","703":"57545901","787":"b45049f8"}[chunkId] + ".chunk.js";
};